window.addEventListener('load', function () {
  setTimeout(initStickySubcategory, 300);
});

function initStickySubcategory() {
  if (window.innerWidth > 767) return;

  var section = document.querySelector('[id$="__subcollection"] slide-section');
  if (!section) return;

  function getHeaderHeight() {
    var header = document.querySelector('header');
    return header ? header.getBoundingClientRect().height : 60;
  }

  var headerHeight = getHeaderHeight();
  var gap = 5;
  var lastScrollY = window.scrollY;
  var ticking = false;

  var marker = document.createElement('div');
  marker.style.height = '1px'; // zero-height markers break IO/geometry checks on some mobile browsers
  section.parentNode.insertBefore(marker, section);

  var spacer = document.createElement('div');
  spacer.style.display = 'none';
  section.parentNode.insertBefore(spacer, section.nextSibling);

  function setStuck(stuck) {
    if (stuck) {
      if (!section.classList.contains('js-sticky-fixed')) {
        spacer.style.height = section.getBoundingClientRect().height + 'px';
        spacer.style.display = 'block';
        section.classList.add('js-sticky-fixed');
      }
    } else {
      if (section.classList.contains('js-sticky-fixed')) {
        section.classList.remove('js-sticky-fixed');
        section.classList.remove('js-scroll-up');
        spacer.style.display = 'none';
      }
    }
  }

  function update() {
    ticking = false;

    var currentScrollY = window.scrollY;
    var scrollingUp = currentScrollY < lastScrollY;
    lastScrollY = currentScrollY;

    // Force-check every time: is marker past the sticky threshold?
    var markerTop = marker.getBoundingClientRect().top;
    var shouldStick = markerTop < (headerHeight + gap);

    setStuck(shouldStick);

    if (section.classList.contains('js-sticky-fixed')) {
      if (scrollingUp) {
        section.classList.add('js-scroll-up');
      } else {
        section.classList.remove('js-scroll-up');
      }
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  // Run once immediately so the correct state is set on load / after any DOM shift
  update();

  window.addEventListener('scroll', onScroll, { passive: true });

  window.addEventListener('resize', function () {
    clearTimeout(window._stickySubcatResizeTimer);
    window._stickySubcatResizeTimer = setTimeout(function () {
      headerHeight = getHeaderHeight();
      update();
    }, 150);
  });
}